import { Trash2, X } from 'lucide-react';
import { useEffect } from 'react';

type ResetDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function ResetDialog({ open, onClose, onConfirm }: ResetDialogProps) {
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] grid place-items-center bg-black/75 p-4" role="presentation" onMouseDown={onClose}>
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="reset-title"
        className="modal-enter w-full max-w-[400px] rounded-2xl border border-border bg-surface-raised p-6 shadow-modal"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="flex items-start gap-3">
          <span className="grid size-10 shrink-0 place-items-center rounded-full bg-danger/10 text-danger"><Trash2 className="size-5" /></span>
          <div className="min-w-0 flex-1">
            <h2 id="reset-title" className="text-lg font-semibold text-primary">Hapus percakapan ini?</h2>
            <p className="mt-4 text-sm leading-6 text-secondary">Seluruh pesan yang tersimpan di browser ini akan dihapus. Tindakan ini tidak dapat dibatalkan.</p>
          </div>
          <button type="button" onClick={onClose} className="icon-button -mr-2 -mt-2" aria-label="Tutup"><X className="size-4" /></button>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" onClick={onClose} className="interactive h-10 rounded-lg border border-border px-4 text-sm font-medium text-primary hover:bg-surface-hover">Batal</button>
          <button type="button" onClick={onConfirm} className="interactive h-10 rounded-lg bg-danger px-4 text-sm font-medium text-white hover:bg-danger/85">Hapus percakapan</button>
        </div>
      </section>
    </div>
  );
}
